import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IntroducersService } from 'src/app/services/api/introducers.service';
import { RouteService } from 'src/app/services/route.service';
import { IntroducerFormComponent } from '../components/introducer-form/introducer-form.component';
import { LoaderComponent } from 'src/app/components/widgets/loader/loader.component';

@Component({
  selector: 'app-introducer-edit-page',
  imports: [IntroducerFormComponent, LoaderComponent],
  templateUrl: './introducer-edit-page.component.html',
  styleUrl: './introducer-edit-page.component.scss',
})
export class IntroducerEditPageComponent {
  introducerId!: number;
  introducer?: any;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private introducersService: IntroducersService,
    private routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.introducerId = Number(this.route.snapshot.paramMap.get('introducerId'));
    if (this.introducerId) {
      this.loadData(this.introducerId);
    }
  }

  loadData(introducerId: number): void {
    this.isLoading = true;
    this.introducersService.detail(introducerId).subscribe({
      next: (response: any) => {
        this.introducer = response.data?.introducer;
        this.isLoading = false;
      },
      error: () => { this.isLoading = false; },
    });
  }

  onSavedData(event: any): void {
    if (event.success) {
      const savedId = event.response?.data?.introducer?.introducerId ?? this.introducerId;
      if (this.introducerId) {
        this.loadData(savedId);
      } else {
        this.routeService.introducerUpdate(savedId);
      }
    }
  }
}
